import { Space } from 'antd';
import { useContext, useMemo } from 'react';

import { CLIENT_SERVICES_LABEL, VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const VisitsServicesLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  const memoizedServiceIds = useMemo(() => {
    return (
      serverFilters.VisitsFilter?.[filterGroupIndex]?.Values?.[0].ServiceIds ||
      []
    );
  }, [serverFilters, filterGroupIndex]);
  const additionalCondition = memoizedServiceIds.length > 0;

  return (
    <Space
      className={`visits-services-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>{CLIENT_SERVICES_LABEL}</span>
      <ClientFilterTag
        filters={filters}
        serverFilters={serverFilters}
        filtersArea={VISITS_FILTER}
        filterGroupIndex={filterGroupIndex}
        setFilters={setFilters}
        setServerFilters={setServerFilters}
        valueKey={
          'ServiceIds' as keyof NClientsList.VisitsFilterUnitValue['ServiceIds']
        }
        additionalCondition={additionalCondition}
      >
        {`Выбрано: ${memoizedServiceIds.length}`}
      </ClientFilterTag>
    </Space>
  );
};
